// @flow

import type {
  SearchSettingsState,
  SearchSettingsAction
} from 'stores/flow-type/search-settings.type';

import {
  GET_SEARCH_SETTINGS_REQUEST,
  GET_SEARCH_SETTINGS_SUCCESS,
  GET_SEARCH_SETTINGS_FAILURE,
  UPDATE_SEARCH_SETTINGS_REQUEST,
  UPDATE_SEARCH_SETTINGS_SUCCESS,
  UPDATE_SEARCH_SETTINGS_FAILURE
} from 'stores/flow-type/search-settings.type';

const initialState: SearchSettingsState = {
  getLoading: false,
  updateLoading: false,
  updateSuccess: false,
  error: undefined,
  searchSettings: {},
  scheduleSyncIn: 0,
  scheduleSyncAfter: 0,
  waitSyncAt: 0
};

const searchSettingsReducers = (
  state: SearchSettingsState = initialState,
  action: SearchSettingsAction
) => {
  switch (action.type) {
    case GET_SEARCH_SETTINGS_REQUEST:
      return { ...state, getLoading: true, waitSyncAt: 0, scheduleSyncIn: 0, scheduleSyncAfter: 0 };

    case GET_SEARCH_SETTINGS_SUCCESS: {
      const { data = {} } = action.payload;
      const { data: searchSettings = {}, waitSyncAt, scheduleSyncIn, scheduleSyncAfter } = data;

      return {
        ...state,
        getLoading: false,
        error: undefined,
        searchSettings,
        waitSyncAt,
        scheduleSyncIn,
        scheduleSyncAfter
      };
    }
    case GET_SEARCH_SETTINGS_FAILURE:
      return {
        ...state,
        getLoading: false,
        error: action.payload,
        waitSyncAt: 0,
        scheduleSyncIn: 0,
        scheduleSyncAfter: 0
      };
    case UPDATE_SEARCH_SETTINGS_REQUEST:
      return {
        ...state,
        updateLoading: true,
        updateSuccess: false,
        waitSyncAt: 0,
        scheduleSyncIn: 0,
        scheduleSyncAfter: 0
      };
    case UPDATE_SEARCH_SETTINGS_SUCCESS: {
      const { data = {} } = action.payload;
      const { data: searchSettings = {}, waitSyncAt, scheduleSyncIn, scheduleSyncAfter } = data;

      return {
        ...state,
        updateLoading: false,
        error: undefined,
        updateSuccess: true,
        searchSettings,
        waitSyncAt,
        scheduleSyncIn,
        scheduleSyncAfter
      };
    }

    case UPDATE_SEARCH_SETTINGS_FAILURE:
      return {
        ...state,
        updateLoading: false,
        updateSuccess: false,
        error: action.payload,
        waitSyncAt: 0,
        scheduleSyncIn: 0,
        scheduleSyncAfter: 0
      };
    default:
      return state;
  }
};

export default searchSettingsReducers;
